import { DateTime } from "luxon";

export function getFriendlyDateFromDateTimeIso(dateTimeIso: string) {
    return DateTime.fromISO(dateTimeIso).setZone("Europe/London").toFormat("EEE d MMM yyyy");
}
